






























import Vue from 'vue'

interface Data {
  isPasswordVisible: boolean
}

interface Methods {}

interface Computed {}

interface Props {
  id: string
  value: string
  name: string
  type?: string
  label?: string
  disable?: boolean
  readonly?: boolean
  mask?: string
  fillMask?: string | boolean
  unmaskedValue?: boolean
  rules?: (() => boolean)[]
  lazyRules?: string | boolean
  noErrorIcon?: boolean
  placeholderText: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Input',
  model: {
    prop: 'value',
    event: 'input',
  },
  data: () => ({
    isPasswordVisible: false,
  }),
  props: {
    id: String,
    value: String,
    name: String,
    type: String,
    label: String,
    disable: Boolean,
    readonly: Boolean,
    mask: String,
    fillMask: [Boolean, String],
    unmaskedValue: Boolean,
    rules: Array,
    lazyRules: {
      type: [Boolean, String],
      required: false,
      default: true,
    },
    noErrorIcon: {
      type: Boolean,
      default: true,
    },
    placeholderText: {
      type: String,
      required: false,
      default: '',
    },
  },
})
